var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M13.189 4.68l7.137 11.249A2 2 0 0 1 18.637 19H4.363a2 2 0 0 1-1.689-3.071l7.137-11.25a2 2 0 0 1 3.378 0zm-.515 3.245H10.42l.476 5.977h1.358l.42-5.977zm-2.226 8.195c0 .616.49 1.106 1.092 1.106.616 0 1.12-.49 1.12-1.106 0-.616-.504-1.12-1.12-1.12-.602 0-1.092.504-1.092 1.12z","id":"warning-a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"warning-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#warning-a"})),React.createElement("g",{"mask":"url(#warning-b)","fill":"currentColor","key":1},React.createElement("path",{"d":"M0 0h23v23H0z"}))])]);
}

Warning.defaultProps = {"viewBox":"0 0 23 23","width":"23","height":"23"};

module.exports = Warning;

Warning.default = Warning;
